import { Button } from "@shapr3d/frontend-lib";

import useNavigation from "../../hooks/navigation";
import useTranslation from "../../hooks/useTranslation";
import Heading from "../Heading/Heading";

import style from "./NonEduEmailWarning.module.css";

interface NonEduEmailWarningProps {
  dismissWarning: () => void;
}

const NonEduEmailWarning: React.FC<NonEduEmailWarningProps> = ({ dismissWarning }) => {
  const { goToProfile } = useNavigation();
  const { t, m } = useTranslation();
  return (
    <section>
      <div className={style.container}>
        <Heading type="h1" className={style.title}>
          {t(m.NonEduEmailWarning.Title)}
        </Heading>
        <p>{t(m.NonEduEmailWarning.Description)}</p>
        <div className={style.buttonContainer}>
          <Button onClick={() => goToProfile()}>{t(m.NonEduEmailWarning.ChangeMyEmail)}</Button>
          <Button variant="grayscale" onClick={dismissWarning}>
            {t(m.NonEduEmailWarning.ContinueAnyways)}
          </Button>
        </div>
      </div>
    </section>
  );
};

export default NonEduEmailWarning;
